import { useQuery, useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { getDataDictionary } from "../../../api";
import { RootStateOrAny, useSelector } from "react-redux";
import LoadingEllipsis from "../../Loading/LoadingEllipsis";

interface DataUpdate {
  view: string;
  kpi: string;
  KPI_definition: string;
  Source: string;
}

const pageMapping: Record<string, string> = {
  volume: "Volume",
  oao: "OaO",
  "image-attributes": "Image",
  "segment-volume-tiv": "Segment TIV",
  "brand-market-share": "Market Share",
  "market-share-by-channel": "Market Share by Channel",
  tp: "TP",
  tpva: "TPVA",
  "brand-kpi-trend": "Brand KPI trend",
  "brand-kpi-summary": "Brand KPI summary",
  "purchase-funnel": "Purchase Funnel",
  nim: "NIM",
  "nim-latest": "NIM Latest",
  "sov/som": "SOV/SOM",
  rv: "RV",
  "image-snapshot": "Image Snapshot",
  "monthly-table-for-download": "Table for download (monthly)",
  "quarterly-table-for-download": "Table for download (quarterly)",
  "yearly-table-for-download": "Table for download (yearly)",
  "rv-table-for-download": "Table for download (RV)",
};

export const BrandPerformanceData = (): JSX.Element => {
  const params = useSelector((state: RootStateOrAny) => state.parameters);
  const activePage = useSelector((state: RootStateOrAny) => state.parameters.performance_page);

  const [dataUpdate, setDataUpdate] = useState<Array<any>>([]);

  // fetch data using react query
  const { isFetching } = useQuery([activePage, params], () => getDataDictionary(pageMapping[activePage] ?? ""), {
    enabled: activePage !== "",// This will prevent the query from running on initial rendery
    onSuccess: (data) => {
      if (Array.isArray(data)) {
        console.log("Data fetched successfully:", data);

        setDataUpdate(data);
      }
    },
  });

  return (
    <div className="data_documentation">
      <h3>BRAND PERFORMANCE - DATA OVERVIEW</h3>

      <br />

      <table className="docs_table">
        <thead>
          <tr>
            <th>Brand</th>
            <th>Country</th>
            <th>Model</th>
            <th>Note</th>
            <th>Note Category</th>
          </tr>
        </thead>
        <tbody>
          {dataUpdate?.map((dataItem: any) => (
            <tr key={dataItem}>
              <td>{dataItem.brand}</td>
              <td>{dataItem.country}</td>
              <td>{dataItem.model}</td>
              <td style={{ whiteSpace: "pre-wrap" }}>{dataItem.note}</td>
              <td>{dataItem.note_category}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <LoadingEllipsis isLoading={isFetching} />
      <br />
      <br />
    </div>
  );
};
